import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getReportsStaffPayments: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENTS,
  },
  getReportsStaffPayment: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT,
  },
  getReportsStaffPaymentPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT_PREVIEW,
  },
}